'use client'
import { forwardRef } from 'react'
import dynamic from 'next/dynamic'

import styles from './ra-background-map.module.scss'

const RaVisual = dynamic(() =>
  import('@/components/core/index.core').then(({ RaVisual }) => RaVisual),
)

interface RaBackgroundMapProps {
  children?: React.ReactNode
}

export const RaBackgroundMap = forwardRef<HTMLDivElement, RaBackgroundMapProps>((props, ref) => {
  return (
    <div
      className={styles['ra-background-map']}
      ref={ref}>
      {props.children}
      <RaVisual color="light" />
    </div>
  )
})

RaBackgroundMap.displayName = 'RaBackgroundMap'
